// Maps the full set of BE PatternStatus codes onto the smaller set of statuses we display.
// Codes with no entry here have no dedicated translation and fall back to the raw status.
export const IMB_STATUS_DISPLAY_MAP = {
    NEW: 'NEW',
    DISMISSED: 'DISMISSED',
    DISMISSED_REM: 'DISMISSED',
    DISMISSED_SETUP: 'DISMISSED',
    FINISHED_DISMISSED: 'DISMISSED',
    IMPROVED: 'IMPROVED',
    IMPROVED_REWORK: 'IMPROVED',
    IMPROVED_COMPLETED: 'IMPROVED',
    TIMEDOUT: 'TIMED_OUT',
    INVALID: 'CANCELED',
    OVER_CORRECTED: 'OVERCORRECTED',
    WORKED_ON: 'NOT_IMPROVED',
    NEEDS_IMPROVEMENT: 'NEEDS_IMPROVEMENT'
};
